(function () {
    'use strict';

    angular
        .module('ib-ancillaries-bundle-module')
        .controller('AncillariesBundleController', AncillariesBundleController);

    AncillariesBundleController.$inject = ['$window', '$rootScope', 'MenusConstants', '$scope', 'localStorageService', 'DatalayerUtilsService', 'DatalayerMenusService'];
    function AncillariesBundleController ($window, $rootScope, MenusConstants, $scope, localStorageService, DatalayerUtilsService, DatalayerMenusService) {
        const vm = this;
        vm.deleteBundle = deleteBundle;

        /**
         * Delete bundle on service  and emit event to delete bundle on ancillaries page
         */
        function deleteBundle (infoBundle) {
            const items = infoBundle.info.items;
            const actualPage ='/' + localStorageService.get('actualStepFlow');
            const passengerBaggagesTrips = localStorageService.get('passengerBaggagesTrips');
            if (actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.BOOKING ||
                actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.CHECKIN ||
                actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.MMB) {
                updateBundleState (actualPage, infoBundle, passengerBaggagesTrips, items);
            } else {
                vm.basketFunctions.deleteAncillariesService.deleteBundleService().then(() => {
                    updateBundleState (actualPage, infoBundle, passengerBaggagesTrips, items);
                    $rootScope.$broadcast('basketUpdateCommonHeader');

                }, (error) => {
                    vm.basketFunctions.isNotLoading();
                    vm.basketFunctions.modalService.setErrorMessage(error.message);
                    vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                    vm.basketFunctions.modalService.isError(error);
                    vm.basketFunctions.collapseHeader.closeCollapse();
                });
            }

            function deleteSegmentBundleSuccess () {
                DatalayerMenusService.deleteBundle(localStorageService.get('selectedBundle'));
                localStorageService.remove('selectedBundle');
                localStorageService.remove('bundleItems');
                infoBundle.hasBundle = false;
                delete infoBundle.info;
            }

            function updateBundleState (actualPage, infoBundle, passengerBaggagesTrips, items) {
                deleteSegmentBundleSuccess();
                $rootScope.$broadcast('deleteBundles', infoBundle);
                $rootScope.$broadcast('unlockItemsFromBundle');
                $rootScope.$broadcast('updateHeaderBaggages', passengerBaggagesTrips);
                vm.basketFunctions.calculateAllBasket(actualPage);
                vm.basketFunctions.saveHeaderModel();
                vm.basketFunctions.isNotLoading();

                items.forEach(item => {
                    switch(item.type) {
                            case 'FLEXIBILITY_ON_DEMAND':
                                $rootScope.$broadcast('cleanFlexibilization');
                                break;
                            case 'PRIORITY_BOARDING':
                                $rootScope.$broadcast('cleanPriorityBoarding');
                                break;
                            default:
                                break;
                    }
                });
            }
        }
    }
})();